///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const RepriceIcon = ({
  height,
  title = messages.reprice.defaultMessage,
  width,
  fill,
  ...rest
}) => (
  <svg
    aria-labelledby="reprice-icon"
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="reprice-icon">{title}</title>
    <g id="svgg">
      <path
        id="path0"
        d="M179.688 15.490 L 179.688 30.980 173.242 31.933 C 122.914 39.377,76.246 72.083,50.972 117.623 C 8.453 194.232,31.784 291.694,104.366 340.671 C 111.632 345.575,108.874 346.427,131.419 332.316 L 150.936 320.101 141.679 315.312 C 45.671 265.644,47.574 129.383,144.922 83.123 C 155.362 78.161,173.059 72.656,178.567 72.656 C 179.498 72.656,179.688 74.973,179.688 86.328 C 179.688 93.848,179.967 100.000,180.308 100.000 C 181.481 100.000,259.766 50.738,259.766 50.000 C 259.766 49.262,181.481 0.000,180.308 0.000 C 179.967 0.000,179.688 6.970,179.688 15.490 M268.478 67.711 L 249.066 79.901 258.322 84.689 C 354.405 134.395,352.502 270.581,255.078 316.877 C 244.638 321.839,226.941 327.344,221.433 327.344 C 220.502 327.344,220.313 325.027,220.313 313.672 C 220.313 306.152,220.033 300.000,219.692 300.000 C 218.519 300.000,140.234 349.262,140.234 350.000 C 140.234 350.738,218.519 400.000,219.692 400.000 C 220.033 400.000,220.313 393.030,220.313 384.510 L 220.313 369.020 226.758 368.051 C 294.279 357.891,351.342 304.559,365.936 237.975 C 381.173 168.456,353.629 98.463,295.634 59.329 C 288.349 54.413,290.917 53.620,268.478 67.711 M189.063 122.553 L 189.063 132.607 184.180 133.961 C 163.140 139.795,150.797 157.050,153.792 176.444 C 156.313 192.775,165.610 200.801,195.041 212.054 C 209.425 217.554,214.054 221.660,214.060 228.928 C 214.071 242.780,188.290 246.060,165.013 235.167 C 162.245 233.872,159.580 232.813,159.089 232.813 C 158.593 232.813,156.873 238.048,155.206 244.636 C 153.561 251.139,152.052 256.883,151.853 257.402 C 151.031 259.543,168.500 265.122,180.664 266.603 L 188.281 267.531 188.281 277.515 L 188.281 287.500 199.219 287.500 L 210.156 287.500 210.156 276.563 C 210.156 267.134,210.326 265.625,211.386 265.625 C 223.366 265.625,241.417 251.595,245.902 238.796 C 254.394 214.561,243.175 197.665,209.766 184.377 C 191.399 177.072,187.109 173.798,187.109 167.084 C 187.109 155.141,207.712 152.344,230.645 161.174 L 235.900 163.197 236.657 160.309 C 237.074 158.721,238.329 153.730,239.447 149.219 C 240.565 144.707,241.663 140.398,241.888 139.644 C 242.646 137.093,229.037 132.754,216.602 131.582 L 210.938 131.048 210.938 121.774 L 210.938 112.500 200.000 112.500 L 189.063 112.500 189.063 122.553 "
        stroke="none"
        fill={fill}
        fillRule="evenodd"
      ></path>
    </g>
  </svg>
);

export default RepriceIcon;
